import React, { Component } from 'react'
import LoadingSpinner from '../spinner/loading.component.jsx'

class ActionButton extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            id: this.props.id || '',
            loadingTimeout: this.props.loadingTimeout,
            className: this.props.className || '',
            type: this.props.type || '',
            style: this.props.style || {},
            onClick: this.props.onClick || function () { },
            disabled: this.props.disabled === true,
            isLoading: false,
            formId: this.props.formId || '',
        }
        this.handleClick = this.handleClick.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        let state = {
            className: nextProps.className || '',
            type: nextProps.type || '',
            disabled: nextProps.disabled === true,
            onClick: nextProps.onClick || function () { },
        }
        if (nextProps.isLoading !== undefined) {
            state.isLoading = nextProps.isLoading
        }
        this.setState(state)
    }

    handleClick(event) {
        if (this.state.isLoading) {
            event.preventDefault()
            return
        }
        this.setState({
            isLoading: true,
            disabled: true,
        })
        this.state.onClick(event)
        if (this.state.loadingTimeout) {
            setTimeout(() => {
                this.setState({
                    isLoading: false,
                    disabled: false,
                })
            }, this.state.loadingTimeout)
        }
    }

    render() {
        let content = this.props.children
        if (this.state.isLoading) {
            let color = 'white'
            if (this.state.className.includes('outline')) {
                color = ''
            }
            content = <LoadingSpinner color={color} height={14} width={3} className="px-5" />
        }

        let buttonProps = {
            style: this.state.style,
            id: this.state.id,
            className: this.state.className,
            disabled: this.state.disabled,
            type: this.state.type,
        }
        if (!this.state.formId) {
            buttonProps.onClick = this.handleClick
        } else if (this.state.formId) {
            buttonProps.form = this.state.formId
        }

        return (
            < button
                {...buttonProps}
            >
                {content}
            </button >
        )
    }
}

export default ActionButton


// WEBPACK FOOTER //
// ./src/common/button/actionbutton.component.jsx